import React from 'react';
import { Button } from '@/components/ui/button';

interface PayrollActionsProps {
  onCancel: () => void;
  onProcess: () => void;
  processing: boolean;
  disabled: boolean;
}

export const PayrollActions: React.FC<PayrollActionsProps> = ({
  onCancel,
  onProcess,
  processing,
  disabled
}) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button 
        onClick={onProcess}
        disabled={disabled}
        className="bg-green-600 hover:bg-green-700"
      >
        {processing ? 'Processing...' : 'Process Payroll'}
      </Button>
    </div>
  );
};